export class PolarCoord {
    constructor(latitude, longitude, radians = false) {
        this.lat = latitude
        this.lng = longitude
        this.RAD = radians
        this.DEG = !radians
    }
    
    /**
     * Convert polar coordinates values to DEGREES
     * @returns {PolarCoord}
     */
    getDEG() {
        if (this.DEG) {
            return this
        }
        return new PolarCoord(this.lat * 180 / Math.PI, this.lng * 180 / Math.PI)
    }
    
    /**
     * Convert polar coordinates values to RADIANS
     * @returns {PolarCoord}
     */
    getRAD() {
        if (this.RAD) {
            return this
        }
        return new PolarCoord(this.lat * Math.PI / 180, this.lng * Math.PI / 180)
    }
    
    /**
     * Convert polar coordinates (RAD) to cartesian coordinates
     * @returns {{x: number, y: number, z: number}}
     */
    cartesianRepresentation() {
        if (this.DEG) {
            return this.getRAD().cartesianRepresentation()
        }
        return {
            x: 6371 * Math.sin(this.lat) * Math.cos(this.lng),
            y: 6371 * Math.sin(this.lat) * Math.sin(this.lng),
            z: 6371 * Math.cos(this.lat),
        }
    }
    
    midpoint(that) {
        return new PolarCoord((this.lat + that.lat) / 2, (this.lng + that.lng) / 2)
    }
    
    /**
     * Calculate midpoint from number of points in polar coordinates
     * @param {PolarCoord} that
     * @returns {{lat: number, lng: number}}
     */
    midpointSpherical(that) {
        let sum = {
            x: (this.x + that.x) / 2,
            y: (this.y + that.y) / 2,
            z: (this.z + that.z) / 2,
        }
        
        var result = new PolarCoord(
            Math.acos(sum.z / Math.sqrt((sum.x * sum.x) + (sum.y * sum.y) + (sum.z * sum.z))),
            Math.atan(sum.y / sum.x),
            true,
        )
        return result.getDEG()
    }
    
    midpointWeighted(points) {
        return points.reduce((result, point) => {
            return result.midpoint(point)
        }, this)
    }
    
    midpointSphericalWeighted(points) {
        return points.reduce((result, point) => {
            return result.midpointSpherical(point)
        }, this)
    }
}


/**
 * Get Google Maps zoom level, with which all markers will be fitted inside map frame
 * @param {{width: number, height: number}} windowBounds Height and width of Google Maps rendered element
 * @param {{dlng: number, dlat: number}} realPolarCoordDelta Latitude and Longitude delta between eastern-western and
 *     north-south bounds
 * @param {PolarCoord} midpoint Where the map should be centered
 * @param {int} maxZoomLevel Maximum allowed zoom level
 * @returns {*}
 */
export function getZoomLevel(windowBounds, realPolarCoordDelta, midpoint, maxZoomLevel) {
    let metersPerPixel = 156543.03392 * Math.cos(midpoint.lat * Math.PI / 180) / Math.pow(2, maxZoomLevel)
    
    let realBoundsMeters = {
        width: realPolarCoordDelta.dlng * Math.cos(midpoint.lat * Math.PI / 180) * 111000,
        height: realPolarCoordDelta.dlat * 111000,
    }
    
    let windowRealBounds = {
        width: windowBounds.width * metersPerPixel,
        height: windowBounds.height * metersPerPixel,
    }
    if ((windowRealBounds.width > realBoundsMeters.width && windowRealBounds.height > realBoundsMeters.height) || maxZoomLevel < 1) {
        return maxZoomLevel
    } else {
        return getZoomLevel(windowBounds, realPolarCoordDelta, midpoint, maxZoomLevel - 1)
    }
}
